
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/insurance/benefits",
      function () {
        return require("private-next-pages/solutions/insurance/benefits.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/insurance/benefits"])
      });
    }
  